import { Card, Text } from '@billda/design-system';
import { PaymentLineItemRow } from './PaymentLineItemRow';

export interface PaymentLineItem {
  id: string;
  name: string;
  amount: number;
  type: 'split' | 'dayRate' | 'solo';
}

interface PaymentBreakdownCardProps {
  items: PaymentLineItem[];
}

export function PaymentBreakdownCard({ items }: PaymentBreakdownCardProps) {
  return (
    <Card className="p-4">
      <Text variant="h6" className="mb-2">
        Payment Breakdown
      </Text>
      <div className="flex flex-col gap-3">
        {items.map(item => (
          <PaymentLineItemRow
            key={item.id}
            name={item.name}
            amount={item.amount}
            subtitle={item.type === 'dayRate' ? 'Day Rate' : undefined}
          />
        ))}
      </div>
    </Card>
  );
}
